/**
 * @description Comscore tag 初始化
 * @param comscoreId
 */
export function initComsorcetag(comscoreId) {
  window._comscore = window._comscore || [];
  window._comscore.push({
    c1: "2",
    c2: comscoreId
    // options: { enableFirstPartyCookie: true }
  });
  (function () {
    var s = document.createElement("script"),
      el = document.getElementsByTagName("script")[0];
    s.async = true;
    s.src = (document.location.protocol == "https:" ? "https://sb" : "http://b") + ".scorecardresearch.com/beacon.js";
    if (el && el.parentNode) {
      el.parentNode.insertBefore(s, el);
    }
  })();
}